<!-- Botón hamburguesa (solo visible en móvil vía CSS) -->
<button class="sidebar-mobile-toggle" type="button" (click)="toggleMobile()" aria-label="Abrir menú">
    <span class="material-icons-round">{{ mobileOpen() ? 'close' : 'menu' }}</span>
</button>

@if (mobileOpen()) {
<div class="sidebar-mobile-overlay" (click)="closeMobile()"></div>
}

<aside class="sidebar-container" [class.sidebar-open]="mobileOpen()">
    <div class="sidebar-header">
        <div class="sidebar-logo-wrapper">
            <!-- N4/#1 — Era un rayo genérico de Heroicons; ahora es la marca. -->
            <img src="/assets/logo-sidebar.png" alt="SureSell" class="sidebar-logo-img" />
            <h1 class="sidebar-title">Suresell</h1>
        </div>
        @if (tenant(); as t) {
        <div class="sidebar-tenant">
            {{ t.tenantName }} · {{ t.userName }}
        </div>
        }
        @if (perfil.perfil(); as p) {
        <div class="sidebar-perfil" [title]="'Perfil vertical: ' + p.nombre">
            <span class="sidebar-perfil-punto"></span>
            {{ p.nombre }}
        </div>
        }
    </div>

    <nav class="sidebar-nav" (click)="closeMobile()">
        <a routerLink="/pos" routerLinkActive="sidebar-link-active" [routerLinkActiveOptions]="{exact: true}"
            class="sidebar-link group">
            <svg xmlns="http://www.w3.org/2000/svg" class="sidebar-link-icon" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            Crear Órdenes
        </a>

        <a *appFeature="'historial'" routerLink="/history" routerLinkActive="sidebar-link-active"
            class="sidebar-link group">
            <svg xmlns="http://www.w3.org/2000/svg" class="sidebar-link-icon" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Historial
        </a>

        <a *appFeature="'cierre'" routerLink="/closure" routerLinkActive="sidebar-link-active"
            class="sidebar-link group">
            <svg xmlns="http://www.w3.org/2000/svg" class="sidebar-link-icon" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z" />
            </svg>
            Cierre de Caja
        </a>

        @if (consumoPropio.personas() !== null) {
        <a routerLink="/consumo-propio" routerLinkActive="sidebar-link-active" class="sidebar-link group" data-testid="menu-consumo-propio">
            <svg xmlns="http://www.w3.org/2000/svg" class="sidebar-link-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h18M5 7h14l-1 13H6L5 7zm4 4v5m6-5v5" />
            </svg>
            Consumo propio
        </a>
        }

        <a *appFeature="'descuentos'" routerLink="/discounts" routerLinkActive="sidebar-link-active"
            class="sidebar-link group">
            <svg xmlns="http://www.w3.org/2000/svg" class="sidebar-link-icon" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Descuentos
        </a>
    </nav>

    <div style="margin-top: auto; padding: var(--esp-4);" (click)="closeMobile()">
        <button (click)="openCashDrawer()" class="sidebar-link group"
            style="width: 100%; border: 1px dashed var(--color-slate-300); background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-4);">
            <span class="material-icons-round sidebar-link-icon">point_of_sale</span>
            Abrir Caja
        </button>
        <!-- En el demo local no hay servidor que registre gastos, bajas ni contraseñas (18/09): no se ofrecen. -->
        @if (!enDemo) {
        <button (click)="registerExpense()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">payments</span>
            Registrar gasto
        </button>
        <button (click)="registerWaste()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">delete_sweep</span>
            Registrar baja
        </button>
        }
        @if (atajoProveedor()) {
        <a [href]="urlMisProveedores" target="_blank" rel="noopener noreferrer" class="sidebar-link group pedir-a-mi-proveedor"
            style="width: 100%; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500); text-decoration: none;">
            <span class="material-icons-round sidebar-link-icon">local_shipping</span>
            Pedir a mi proveedor
        </a>
        }
        @if (isAdmin()) {
        <button (click)="manageUsers()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">group</span>
            Usuarios
        </button>
        <!-- Meseros solo donde la venta pasa por mesa o rastreador (2026-09-09): en DIRECTO no hay quien tome el pedido. -->
        @if (tableService.conMeseros()) {
        <button (click)="manageWaiters()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">room_service</span>
            {{ perfil.termino('vendedor', 'pt') }}
        </button>
        }
        <!-- El vendedor de las ventas (Santiago y ECM, 20/09): se elige aquí, no en cada venta, y se queda puesto
             hasta que alguien lo cambie. Con sesión de vendedor no hay nada que elegir: es él. -->
        @if (puedeElegirVendedor()) {
        <button (click)="elegirVendedor()" class="sidebar-link group" data-testid="sidebar-vendedor"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">badge</span>
            Vendedor: {{ vendedorElegido() }}
        </button>
        }
        <!-- N3 — Solo tiene sentido en modo Restaurante. -->
        @if (tableService.esRestaurante()) {
        <button (click)="configureTables()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">table_restaurant</span>
            Mesas
        </button>
        }
        <!-- N3/#3 — Los rastreadores solo existen en flujo RASTREADOR (T4). -->
        @if (tableService.usaRastreador()) {
        <button (click)="configurePagers()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">vibration</span>
            Rastreadores
        </button>
        }
        <button (click)="editBusiness()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">store</span>
            Datos del negocio
        </button>
        }
        @if (!enDemo) {
        <button (click)="changePassword()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">lock</span>
            Cambiar contraseña
        </button>
        }
        <button (click)="logout()" class="sidebar-link group"
            style="width: 100%; border: none; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; gap: var(--esp-2); margin-top: var(--esp-3); font-size: var(--texto-xs); color: var(--color-slate-500);">
            <span class="material-icons-round sidebar-link-icon">logout</span>
            Cerrar sesión
        </button>

        <!-- N3 — El estado de la impresora va al FONDO: en medio de la lista
             cortaba las opciones y las empujaba fuera de la vista. -->
        <!-- Indicador honesto (docs/arquitectura/21 §2.4): «Impresora lista»
             solo cuando se comprobó; «Agente conectado» cuando responde sin poder
             afirmar más; rojo cuando no responde. Nada si la sede no imprime. -->
        @if (impresion.activa()) {
        <div class="sidebar-printer-status" [class.sidebar-printer-ok]="indicadorImpresion()?.nivel === 'ok'"
            [class.sidebar-printer-aviso]="indicadorImpresion()?.nivel === 'aviso'"
            [class.sidebar-printer-error]="indicadorImpresion()?.nivel === 'error'">
            @if (indicadorImpresion(); as ind) {
            <button type="button" class="sidebar-printer-estado" (click)="reintentarImpresion()"
                title="Volver a buscar el programa de impresión" data-testid="indicador-agente">
                <span class="sidebar-printer-dot"></span>
                <span class="sidebar-printer-texto">{{ ind.texto }}</span>
            </button>
            }
            <!-- Diseño 22 §6: ajuste de ESTE equipo, no del negocio. 04/10 (Santiago): oculto mientras el agente no se
                 usa (ImpresionService.AGENTE_EN_USO). -->
            @if (agenteEnUso) {
            <label class="sidebar-printer-via" (click)="$event.stopPropagation()">
                <input type="checkbox" data-testid="imprimir-con-navegador"
                    [checked]="impresion.viaActual() === 'navegador'" [disabled]="impresion.viaActual() === null"
                    (change)="cambiarVia($any($event.target).checked)">
                Imprimir con el navegador
            </label>
            }
            <button type="button" class="sidebar-printer-probar" (click)="probarImpresion()"
                [disabled]="probandoImpresion()" title="Imprime un ticket corto de prueba">
                <span class="material-icons-round">print</span>
                Probar impresión
            </button>
        </div>
        }

        <!-- Qué versión se está viendo, para que un reporte no empiece adivinando. La escribe el despliegue. -->
        <app-version-servida />
    </div>
</aside>
<app-usuarios-del-negocio />
